import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { bulkSubmitRouteRef, rootRouteRef, submitRouteRef } from './routes';
import { recertificationApiRef, RecertificationClient } from './api';

export const recertificationPlugin = createPlugin({
  id: 'recertification',
  routes: {
    root: rootRouteRef,
    submit: submitRouteRef,
    bulkSubmit: bulkSubmitRouteRef,
  },
  apis: [
    createApiFactory({
      api: recertificationApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RecertificationClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const RecertificationPage = recertificationPlugin.provide(
  createRoutableExtension({
    name: 'RecertificationPage',
    component: () =>
      import('./components/RecertificationPage').then(m => m.RecertificationPage),
    mountPoint: rootRouteRef,
  }),
);

export const RecertifySubmitPage = recertificationPlugin.provide(
  createRoutableExtension({
    name: 'RecertifySubmitPage',
    component: () =>
      import('./components/RecertifySubmitPage').then(m => m.RecertifySubmitPage),
    mountPoint: submitRouteRef,
  }),
);

export const BulkRecertifySubmitPage = recertificationPlugin.provide(
  createRoutableExtension({
    name: 'BulkRecertifySubmitPage',
    component: () =>
      import('./components/BulkRecertifySubmitPage').then(
        m => m.BulkRecertifySubmitPage,
      ),
    mountPoint: bulkSubmitRouteRef,
  }),
);
